webpackJsonp([27,47],{

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__database_firebase_firebase_initialize__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Alert_vue__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Alert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Alert: __WEBPACK_IMPORTED_MODULE_3__Alert_vue___default.a
  },
  props: ['activatorText', 'trigger', 'active'],
  data: function data() {
    return {
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        email: function email(value) {
          var pattern = /^(([^<>()[]\\.,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      },
      mail: '',
      companySearch: null,
      companydirectory: [],
      companyLoading: false,
      notavailable: true,
      signUp: {
        email: '',
        password: '',
        lastname: '',
        firstname: '',
        jobtitle: '',
        department: '',
        companylegalname: '',
        businesswebsite: '',
        createdAt: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).format('YYYY-MM-DD')
      },
      signIn: {
        email: '',
        password: ''
      },
      test: true,
      items: ['SIGN-UP', 'SIGN-IN'],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    };
  },
  methods: {
    handleSignUp: function handleSignUp() {
      this.$store.dispatch('signUserUp', this.signUp);
    },
    onDismiss: function onDismiss() {
      this.$store.dispatch('setError', null);
    },
    handleSignIn: function handleSignIn() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('signUserIn', _this.signIn);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.$router.push('/');
    },
    signUpWithGoogle: function signUpWithGoogle() {
      var provider = new __WEBPACK_IMPORTED_MODULE_2__database_firebase_firebase_initialize__["a" /* firebase */].auth.GoogleAuthProvider();
      var store = this.$store;
      return this.$firebase.auth().signInWithPopup(provider).then(function (result) {
        store.dispatch('signUpViaGoogle', result.user);
      }).catch(function (error) {
        store.commit('setError', error);
      });
    },
    signInWithGoogle: function signInWithGoogle() {
      var provider = new __WEBPACK_IMPORTED_MODULE_2__database_firebase_firebase_initialize__["a" /* firebase */].auth.GoogleAuthProvider();
      var store = this.$store;
      return this.$firebase.auth().signInWithPopup(provider).then(function (result) {
        store.dispatch('signInViaGoogle', result.user);
      }).catch(function (error) {
        store.commit('setError', error);
      });
    },
    querySelections: function querySelections(v) {
      var _this2 = this;

      this.loading = true; // Simulated ajax query

      setTimeout(function () {
        _this2.items = _this2.states.filter(function (e) {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
        });
        _this2.loading = false;
      }, 500);
    }
  },
  computed: {
    dialog: function dialog() {
      return this.trigger;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    signInProcess: function signInProcess() {
      return this.$store.getters.getProcess === 'Sign In';
    },
    signUpProcess: function signUpProcess() {
      return this.$store.getters.getProcess === 'Sign Up';
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    fullscreen: function fullscreen() {
      return true; // return screen.availWidth < 600
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    }
  },
  watch: {
    companySearch: function companySearch(val) {
      var _this3 = this;

      val = val.toUpperCase();
      this.companyLoading = true;
      this.$store.dispatch('getContractors', {
        search: val
      }).then(function (res) {
        var i;
        _this3.companydirectory = [];

        for (i = 0; i < res.data.data.length; i++) {
          _this3.companydirectory.push(res.data.data[i].companylegalname);
        }

        if (_this3.companydirectory.length === 0 && val.length >= 2) {
          _this3.notavailable = false;
        }

        _this3.companyLoading = false;
        _this3.signUp.companylegalname = val;
      });
    },
    user: function user(value) {
      if (value.uid != null && value.uid !== undefined) {
        this.$router.push('/user/feed');
      }
    },
    fullscreen: function fullscreen(value) {
      alert('fullscreen');
    },
    search: function search(val) {
      val && this.querySelections(val);
    }
  }
};

/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Alegreya+Sans+SC:900);", ""]);

// module
exports.push([module.i, ".bold{font-family:Alegreya Sans SC,sans-serif}.header{background-color:#f5f5f5;border-style:none;border-bottom:thin solid #d1d0cf;border-bottom-width:2px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/modal/RegistrationComponent.vue"],"names":[],"mappings":"AAEA,MACE,uCAA4C,CAC7C,AACD,QACE,yBAAqC,AACrC,kBAAmB,AACnB,iCAAkC,AAClC,uBAAyB,CAC1B","file":"RegistrationComponent.vue","sourcesContent":["\n@import url('https://fonts.googleapis.com/css?family=Alegreya+Sans+SC:900');\n.bold {\n  font-family: 'Alegreya Sans SC', sans-serif;\n}\n.header {\n  background-color: rgb(245, 245, 245);\n  border-style: none;\n  border-bottom: thin solid #d1d0cf;\n  border-bottom-width: 2px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1190:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1168);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("dbbf07ea", content, true, {});

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1190)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1125),
  /* template */
  __webpack_require__(1236),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "600px",
      "persistent": "",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-tabs', {
    attrs: {
      "light": "",
      "fixed": "",
      "centered": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "header"
  }, [_c('v-tabs-slider', {
    staticClass: "yellow"
  }), _vm._v(" "), _vm._l((_vm.items), function(i) {
    return _c('v-tabs-item', {
      key: i,
      staticStyle: {
        "border": "none"
      },
      attrs: {
        "href": '#' + i,
        "router": ""
      }
    }, [_c('b', [_vm._v(_vm._s(i))])])
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1)], 2), _vm._v(" "), _c('v-tabs-content', {
    staticStyle: {
      "height": "100%",
      "border": "none"
    },
    attrs: {
      "id": "SIGN-UP"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-card-title', {
    staticClass: "bold title pb-1 mt-0 pt-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("CREATE AN ACCOUNT")]), _vm._v(" "), _c('b', {
    staticClass: "caption pt-0 pb-2"
  }, [_vm._v("continue with")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "red accent-4 white--text mr-1",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signUpWithGoogle.apply(null, arguments)
      }
    }
  }, [_vm._v("Sign up with Gmail")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "green accent4 white--text ml-1",
    attrs: {
      "block": ""
    }
  }, [_vm._v("Sign up with LinkedIn")])], 1)], 1), _vm._v(" "), _c('b', {
    staticClass: "caption mt-2 pb-0"
  }, [_vm._v("or")]), _vm._v(" "), _c('form', {
    staticClass: "py-0 my-0 mt-0",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSignUp.apply(null, arguments)
      }
    }
  }, [_c('v-container', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    ref: "confirmation",
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px",
      "margin": "0px"
    },
    attrs: {
      "label": "Email Address",
      "type": "email",
      "required": "",
      "error": false,
      "hide-details": ""
    },
    model: {
      value: (_vm.signUp.email),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "email", $$v)
      },
      expression: "signUp.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    ref: "confirmation",
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Password",
      "type": "password",
      "hint": "At least 6 characters",
      "required": "",
      "counter": "6"
    },
    model: {
      value: (_vm.signUp.password),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "password", $$v)
      },
      expression: "signUp.password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "First Name",
      "required": ""
    },
    model: {
      value: (_vm.signUp.firstname),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "firstname", $$v)
      },
      expression: "signUp.firstname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Last Name",
      "required": ""
    },
    model: {
      value: (_vm.signUp.lastname),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "lastname", $$v)
      },
      expression: "signUp.lastname"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Job Title",
      "required": "",
      "error": false
    },
    model: {
      value: (_vm.signUp.jobtitle),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "jobtitle", $$v)
      },
      expression: "signUp.jobtitle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Department",
      "required": ""
    },
    model: {
      value: (_vm.signUp.department),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "department", $$v)
      },
      expression: "signUp.department"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.notavailable) ? _c('v-select', {
    staticClass: "pr-2 mt-0",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Company Name",
      "cache-items": "",
      "loading": _vm.companyLoading,
      "items": _vm.companydirectory,
      "search-input": _vm.companySearch,
      "autocomplete": "",
      "required": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.companySearch = $event
      },
      "update:search-input": function($event) {
        _vm.companySearch = $event
      }
    },
    model: {
      value: (_vm.signUp.companylegalname),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "companylegalname", $$v)
      },
      expression: "signUp.companylegalname"
    }
  }) : _c('v-text-field', {
    staticClass: "pr-2 mt-0",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Company Name",
      "required": ""
    },
    model: {
      value: (_vm.signUp.companylegalname),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "companylegalname", $$v)
      },
      expression: "signUp.companylegalname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Company Website",
      "required": ""
    },
    model: {
      value: (_vm.signUp.businesswebsite),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "businesswebsite", $$v)
      },
      expression: "signUp.businesswebsite"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    staticClass: "mr-2",
    attrs: {
      "id": "terms",
      "type": "checkbox",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_vm._v("Agree to the Terms & Conditions")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_vm._v("Privacy Policy")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 mb-0 pb-0",
    attrs: {
      "cloumn": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [(!_vm.error || !_vm.signUpProcess) ? _c('v-btn', {
    staticClass: "blue accent-4 white--text",
    attrs: {
      "type": "submit",
      "disable": _vm.loading,
      "loading": _vm.loading
    }
  }, [_vm._v("\n                  Create Account\n                  "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.error && _vm.signUpProcess) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('alert', {
    staticClass: "py-2",
    attrs: {
      "text": _vm.error,
      "error": true,
      "success": false
    },
    on: {
      "dismissed": _vm.onDismiss
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "SIGN-IN"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-card-title', {
    staticClass: "bold title pb-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("SIGN IN TO YOUR ACCOUNT")]), _vm._v(" "), _c('b', {
    staticClass: "caption pt-0 pb-2"
  }, [_vm._v("continue with")]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "red accent-4 white--text mr-1",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signInWithGoogle.apply(null, arguments)
      }
    }
  }, [_vm._v("Sign in with Google")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "green accent-4 white--text ml-1",
    attrs: {
      "block": ""
    }
  }, [_vm._v("Sign in with LinkedIn")])], 1)], 1), _vm._v(" "), _c('b', {
    staticClass: "caption mt-2 mb-0"
  }, [_vm._v("or")]), _vm._v(" "), _c('form', {
    staticClass: "py-0 my-0",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSignIn.apply(null, arguments)
      }
    }
  }, [_c('v-container', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px",
      "margin": "0px"
    },
    attrs: {
      "label": "Email Address",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.signIn.email),
      callback: function($$v) {
        _vm.$set(_vm.signIn, "email", $$v)
      },
      expression: "signIn.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.signIn.password),
      callback: function($$v) {
        _vm.$set(_vm.signIn, "password", $$v)
      },
      expression: "signIn.password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "cloumn": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [(!_vm.error || !_vm.signInProcess) ? _c('v-btn', {
    staticClass: "blue accent-4 white--text",
    attrs: {
      "type": "submit",
      "disable": _vm.loading,
      "loading": _vm.loading
    }
  }, [_vm._v("\n                      Log In\n                      "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.error && _vm.signInProcess) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('alert', {
    staticClass: "py-2",
    attrs: {
      "text": _vm.error,
      "error": true,
      "success": false
    },
    on: {
      "dismissed": _vm.onDismiss
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modal_RegistrationComponent_vue__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modal_RegistrationComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modal_RegistrationComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mdi_css_materialdesignicons_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mdi_css_materialdesignicons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteFooter_vue__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SiteFooter_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    RegistrationComponent: __WEBPACK_IMPORTED_MODULE_0__components_modal_RegistrationComponent_vue___default.a,
    SiteFooter: __WEBPACK_IMPORTED_MODULE_2__components_SiteFooter_vue___default.a
  },
  data: function data() {
    return {
      parallaxHeight: 600,
      dialog: false,
      active: 'SIGN-UP',
      showHeaderBackground: false
    };
  },
  beforeMount: function beforeMount() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    this.$store.dispatch('setInitializing', false);
    var mainApp = document.getElementById('app');

    if (mainApp) {
      document.getElementById('app').style.backgroundColor = this.site_settings.styles.landing.background_color || '#fff';
      document.getElementById('app').style.fontSize = this.site_settings.styles.landing.font_size;
    }
  },
  methods: {
    openRegistartionModal: function openRegistartionModal() {
      this.trigger = !this.trigger;
    },
    goTo: function goTo(link) {
      this.$router.push(link);
    },
    handleScroll: function handleScroll() {
      if (window.scrollY >= 500) {
        document.getElementById('header-block').classList.add('active-background');
      } else {
        document.getElementById('header-block').classList.remove('active-background');
      }
    }
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    site_settings: function site_settings() {
      return this.$store.getters.getSettings;
    },
    landing_page: function landing_page() {
      return this.$store.getters.getSettings.pages.landing_pages;
    },
    sections: function sections() {
      return this.$store.getters.getLandingPage;
    }
  },
  watch: {
    hash: function hash(value) {
      alert(value);
    }
  }
};

/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Alegreya+Sans+SC:900);", ""]);

// module
exports.push([module.i, ".nav-colored[data-v-8096ad9c]{background-color:rgba(0,0,0,.5)}h3[data-v-8096ad9c]{font-size:2rem;font-stretch:condensed;font-family:Roboto}@media (max-width:768px){h3[data-v-8096ad9c]{font-size:1.5rem}}h5[data-v-8096ad9c]{font-size:1.5rem;font-stretch:condensed;font-family:Roboto}@media (max-width:768px){h5[data-v-8096ad9c]{font-size:1rem}}.card-item[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;margin:auto;padding:20px 0;background-color:rgba(0,0,0,.5);-webkit-box-flex:0.3;-ms-flex:0.3 1 auto;flex:0.3 1 auto}.row-divider[data-v-8096ad9c]{margin:30px auto}@media (min-width:767px){.row-divider[data-v-8096ad9c]{width:85%}}.footer-divider-first[data-v-8096ad9c]{margin:70px auto auto}.footer-divider-second[data-v-8096ad9c]{margin:100px auto auto}.dashed-divider[data-v-8096ad9c]{border-top:1px dashed;background-color:#bbb}.auth-button[data-v-8096ad9c]{font-size:16px;font-stretch:condensed;color:#fff}.signup-button[data-v-8096ad9c]{background-color:#fff!important;color:#049ded;font-stretch:condensed;border-radius:5px}.signup-button[data-v-8096ad9c]:hover{color:#049ded}.signin-button[data-v-8096ad9c]{background-color:#049ded!important;color:#fff;font-stretch:condensed;border-radius:5px}.signin-button[data-v-8096ad9c]:hover{background-color:#299b47!important}.action-button[data-v-8096ad9c]{background-color:#999!important;color:#049ded;font-stretch:condensed;border-radius:5px}.feedback[data-v-8096ad9c]{background-color:orange!important;color:#fff}p[data-v-8096ad9c]{font-family:Roboto}.button-text[data-v-8096ad9c]{font-family:Roboto;font-weight:700;font-size:20px}.landing-page[data-v-8096ad9c]{height:100%;margin:0}.no-parallax .parallax__image-container .parallax__content[data-v-8096ad9c]{padding:0!important}.header-block[data-v-8096ad9c]{max-height:80px;padding:10px 0 10px 10px;position:fixed;margin-left:-16px;top:0;width:100%}.active-background[data-v-8096ad9c]{background-color:rgba(0,0,0,.5)}.parallax-card[data-v-8096ad9c]{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;margin-top:60px;max-height:400px}.parallax-buttons[data-v-8096ad9c],.parallax-card[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.parallax-buttons[data-v-8096ad9c]{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;width:100%;margin:50px auto}@media (min-width:768px){.parallax-buttons[data-v-8096ad9c]{width:30%;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.parallax-buttons .get-started-button[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin-top:10px;-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%}@media (min-width:768px){.parallax-buttons .get-started-button[data-v-8096ad9c]{margin-left:auto;margin-right:5px}}.parallax-buttons .returning-users-button[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin-top:10px;-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%}@media (min-width:768px){.parallax-buttons .returning-users-button[data-v-8096ad9c]{margin-right:auto;margin-left:5px}}.landing-header[data-v-8096ad9c]{padding:10px 15px 0;height:60px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:row;-ms-flex-pack:row;justify-content:row;width:100%}.landing-header div[data-v-8096ad9c]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.landing-header .logo-div[data-v-8096ad9c]{width:30%;height:100%;margin-right:auto}.landing-header .logo-div img[data-v-8096ad9c]{max-width:100%;max-height:100%}.gdx-area[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (min-width:767px){.gdx-area[data-v-8096ad9c]{width:80%;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin:70px auto 80px}}.gdx-area .gdx-area-text[data-v-8096ad9c]{background-color:#e4e3e4}.gdx-area .gdx-area-text .gdx-area-text-div[data-v-8096ad9c],.gdx-area .gdx-area-text[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.gdx-area .gdx-area-text .gdx-area-text-div[data-v-8096ad9c]{min-height:173px;margin:60px 30px}.gdx-area .gdx-area-text .gdx-area-text-div .gdx-paragraph[data-v-8096ad9c]{text-align:center;font-size:14px;font-family:Verdana,sans-serif;color:#303131}.gdx-area .gdx-mid-logo[data-v-8096ad9c]{background-color:#5d5d5d}.gdx-area .gdx-mid-logo .img-div[data-v-8096ad9c],.gdx-area .gdx-mid-logo[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.gdx-area .gdx-mid-logo .img-div[data-v-8096ad9c]{height:173px;margin:60px 20px}.gdx-area .gdx-mid-logo .img-div img[data-v-8096ad9c]{max-height:100%;max-width:100%;vertical-align:middle}.info-area[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex}@media (min-width:768px){.info-area[data-v-8096ad9c]{margin:20px auto 50px}}.info-text[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#303131}@media (min-width:768px){.info-text[data-v-8096ad9c]{margin:70px auto 0}}.info-area-header[data-v-8096ad9c]{font-family:Roboto;font-stretch:condensed;font-size:14px;text-transform:uppercase;color:#666;font-weight:700;margin-bottom:5px}.info-area-text[data-v-8096ad9c]{font-family:Verdana;font-size:14px;line-height:20px;color:#666}.action-item[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.action-item .full-button[data-v-8096ad9c]{width:100%}.action-item .info-header-container[data-v-8096ad9c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.action-item .text-div[data-v-8096ad9c]{min-height:100px}.content-area[data-v-8096ad9c]{height:100%;margin-bottom:20px}@media (max-width:767px){.content-area .info-area[data-v-8096ad9c]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.privacy-header[data-v-8096ad9c]{font-family:Roboto;font-stretch:condensed;font-size:14px;text-transform:uppercase;color:#666;font-weight:700;margin-bottom:20px}.bold[data-v-8096ad9c]{font-family:Alegreya Sans SC,sans-serif}.body-bg[data-v-8096ad9c]{background:#fff}#top[data-v-8096ad9c]{position:absolute;top:15px;right:50px;color:#fff}#footer[data-v-8096ad9c]{background:#eee;background-color:#e0e0e0}.no-box-shadow[data-v-8096ad9c]{-webkit-box-shadow:none;box-shadow:none}.text-uppercase[data-v-8096ad9c]{text-transform:uppercase}.case-study[data-v-8096ad9c]{height:270px!important}.footer-bg[data-v-8096ad9c]{background:#f3f3f3;height:auto}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/IndexView.vue"],"names":[],"mappings":"AAEA,8BACE,+BAAqC,CACtC,AACD,oBACE,eAAgB,AAChB,uBAAwB,AACxB,kBAAsB,CACvB,AACD,yBACA,oBACM,gBAAkB,CACvB,CACA,AACD,oBACE,iBAAkB,AAClB,uBAAwB,AACxB,kBAAsB,CACvB,AACD,yBACA,oBACM,cAAgB,CACrB,CACA,AACD,4BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,YAAa,AACb,YAAa,AACb,eAAkB,AAClB,gCAAqC,AACrC,qBAAsB,AAClB,oBAAqB,AACjB,eAAiB,CAC1B,AACD,8BACE,gBAAkB,CACnB,AACD,yBACA,8BACM,SAAW,CAChB,CACA,AACD,uCACE,qBAA4B,CAC7B,AACD,wCACE,sBAA6B,CAC9B,AACD,iCACE,sBAAuB,AACvB,qBAA0B,CAC3B,AACD,8BACE,eAAgB,AAChB,uBAAwB,AACxB,UAAe,CAChB,AACD,gCACE,gCAAqC,AACrC,cAAe,AACf,uBAAwB,AACxB,iBAAmB,CACpB,AACD,sCACI,aAAe,CAClB,AACD,gCACE,mCAAqC,AACrC,WAAe,AACf,uBAAwB,AACxB,iBAAmB,CACpB,AACD,sCACI,kCAAqC,CACxC,AACD,gCACE,gCAAqC,AACrC,cAAe,AACf,uBAAwB,AACxB,iBAAmB,CACpB,AACD,2BACE,kCAAqC,AACrC,UAAe,CAChB,AACD,mBACE,kBAAsB,CACvB,AACD,8BACE,mBAAsB,AACtB,gBAAkB,AAClB,cAAgB,CACjB,AACD,+BACE,YAAa,AACb,QAAU,CACX,AACD,4EACE,mBAAsB,CACvB,AACD,+BACE,gBAAiB,AACjB,yBAA0B,AAC1B,eAAgB,AAChB,kBAAmB,AACnB,MAAO,AACP,UAAY,CACb,AACD,oCACE,+BAAqC,CACtC,AACD,gCAIE,8BAA+B,AAE3B,uBAAwB,AACpB,mBAAoB,AAO5B,gBAAiB,AACjB,gBAAkB,CACnB,AACD,mEAhBE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAEd,6BAA8B,AAG9B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAoB7B,AAhBD,mCAIE,4BAA6B,AAEzB,0BAA2B,AACvB,sBAAuB,AAO/B,WAAY,AACZ,gBAAkB,CACnB,AACD,yBACA,mCACM,UAAW,AACX,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,kBAAoB,CACjC,CACA,AACD,uDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,gBAAiB,AACjB,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACzB,AACD,yBACA,uDACQ,iBAAkB,AAClB,gBAAkB,CACzB,CACA,AACD,2DACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,gBAAiB,AACjB,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACzB,AACD,yBACA,2DACQ,kBAAmB,AACnB,eAAiB,CACxB,CACA,AACD,iCACE,oBAA4B,AAC5B,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,oBAAqB,AAC7B,UAAY,CACb,AACD,qCACI,mBAAoB,AAChB,kBAAmB,AACf,aAAe,CAC1B,AACD,2CACI,UAAW,AACX,YAAa,AACb,iBAAmB,CACtB,AACD,+CACM,eAAgB,AAChB,eAAiB,CACtB,AACD,2BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,yBACA,2BACM,UAAW,AACX,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,qBAA4B,CACjC,CACA,AACD,0CACI,wBAA0B,CAW7B,AACD,uGAXI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAenC,AAbD,6DACM,iBAAkB,AAWlB,gBAAkB,CACvB,AACD,4EACQ,kBAAmB,AACnB,eAAgB,AAChB,+BAAmC,AACnC,aAAe,CACtB,AACD,yCAWI,wBAA0B,CAC7B,AACD,2FAZI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAgBnC,AAbD,kDACM,aAAc,AAWd,gBAAkB,CACvB,AACD,sDACQ,gBAAiB,AACjB,eAAgB,AAChB,qBAAuB,CAC9B,AACD,4BACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,yBACA,4BACM,qBAA4B,CACjC,CACA,AACD,4BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,aAAe,CAChB,AACD,yBACA,4BACM,kBAAyB,CAC9B,CACA,AACD,mCACE,mBAAsB,AACtB,uBAAwB,AACxB,eAAgB,AAChB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,AAClB,iBAAmB,CACpB,AACD,iCACE,oBAAuB,AACvB,eAAgB,AAChB,iBAAkB,AAClB,UAAe,CAChB,AACD,8BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,2CACI,UAAY,CACf,AACD,qDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,wCACI,gBAAkB,CACrB,AACD,+BACE,YAAa,AACb,kBAAoB,CACrB,AACD,yBACA,0CACM,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CACpC,CACA,AACD,iCACE,mBAAsB,AACtB,uBAAwB,AACxB,eAAgB,AAChB,yBAA0B,AAC1B,WAAe,AACf,gBAAkB,AAClB,kBAAoB,CACrB,AACD,uBACE,uCAA4C,CAC7C,AACD,0BACE,eAAiB,CAClB,AACD,sBACE,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,UAAY,CACb,AACD,yBACE,gBAAoB,AACpB,wBAA0B,CAC3B,AACD,gCACE,wBAAyB,AACjB,eAAiB,CAC1B,AACD,iCACE,wBAA0B,CAC3B,AACD,6BACE,sBAAyB,CAC1B,AACD,4BACE,mBAAoB,AACpB,WAAa,CACd","file":"IndexView.vue","sourcesContent":["\n@import url(\"https://fonts.googleapis.com/css?family=Alegreya+Sans+SC:900\");\n.nav-colored[data-v-8096ad9c] {\n  background-color: rgba(0, 0, 0, 0.5);\n}\nh3[data-v-8096ad9c] {\n  font-size: 2rem;\n  font-stretch: condensed;\n  font-family: 'Roboto';\n}\n@media (max-width: 768px) {\nh3[data-v-8096ad9c] {\n      font-size: 1.5rem;\n}\n}\nh5[data-v-8096ad9c] {\n  font-size: 1.5rem;\n  font-stretch: condensed;\n  font-family: 'Roboto';\n}\n@media (max-width: 768px) {\nh5[data-v-8096ad9c] {\n      font-size: 1rem;\n}\n}\n.card-item[data-v-8096ad9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: 100%;\n  margin: auto;\n  padding: 20px 0px;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-box-flex: 0.3;\n      -ms-flex: 0.3 1 auto;\n          flex: 0.3 1 auto;\n}\n.row-divider[data-v-8096ad9c] {\n  margin: 30px auto;\n}\n@media (min-width: 767px) {\n.row-divider[data-v-8096ad9c] {\n      width: 85%;\n}\n}\n.footer-divider-first[data-v-8096ad9c] {\n  margin: 70px auto auto auto;\n}\n.footer-divider-second[data-v-8096ad9c] {\n  margin: 100px auto auto auto;\n}\n.dashed-divider[data-v-8096ad9c] {\n  border-top: 1px dashed;\n  background-color: #bbbbbb;\n}\n.auth-button[data-v-8096ad9c] {\n  font-size: 16px;\n  font-stretch: condensed;\n  color: #FFFFFF;\n}\n.signup-button[data-v-8096ad9c] {\n  background-color: #FFFFFF !important;\n  color: #049DED;\n  font-stretch: condensed;\n  border-radius: 5px;\n}\n.signup-button[data-v-8096ad9c]:hover {\n    color: #049DED;\n}\n.signin-button[data-v-8096ad9c] {\n  background-color: #049DED !important;\n  color: #FFFFFF;\n  font-stretch: condensed;\n  border-radius: 5px;\n}\n.signin-button[data-v-8096ad9c]:hover {\n    background-color: #299b47 !important;\n}\n.action-button[data-v-8096ad9c] {\n  background-color: #999999 !important;\n  color: #049DED;\n  font-stretch: condensed;\n  border-radius: 5px;\n}\n.feedback[data-v-8096ad9c] {\n  background-color: #ffa500 !important;\n  color: #FFFFFF;\n}\np[data-v-8096ad9c] {\n  font-family: 'Roboto';\n}\n.button-text[data-v-8096ad9c] {\n  font-family: 'Roboto';\n  font-weight: bold;\n  font-size: 20px;\n}\n.landing-page[data-v-8096ad9c] {\n  height: 100%;\n  margin: 0;\n}\n.no-parallax .parallax__image-container .parallax__content[data-v-8096ad9c] {\n  padding: 0 !important;\n}\n.header-block[data-v-8096ad9c] {\n  max-height: 80px;\n  padding: 10px 0 10px 10px;\n  position: fixed;\n  margin-left: -16px;\n  top: 0;\n  width: 100%;\n}\n.active-background[data-v-8096ad9c] {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.parallax-card[data-v-8096ad9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 60px;\n  max-height: 400px;\n}\n.parallax-buttons[data-v-8096ad9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  margin: 50px auto;\n}\n@media (min-width: 768px) {\n.parallax-buttons[data-v-8096ad9c] {\n      width: 30%;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n}\n}\n.parallax-buttons .get-started-button[data-v-8096ad9c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    margin-top: 10px;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 50%;\n            flex: 1 1 50%;\n}\n@media (min-width: 768px) {\n.parallax-buttons .get-started-button[data-v-8096ad9c] {\n        margin-left: auto;\n        margin-right: 5px;\n}\n}\n.parallax-buttons .returning-users-button[data-v-8096ad9c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    margin-top: 10px;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 50%;\n            flex: 1 1 50%;\n}\n@media (min-width: 768px) {\n.parallax-buttons .returning-users-button[data-v-8096ad9c] {\n        margin-right: auto;\n        margin-left: 5px;\n}\n}\n.landing-header[data-v-8096ad9c] {\n  padding: 10px 15px 0px 15px;\n  height: 60px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: row;\n      -ms-flex-pack: row;\n          justify-content: row;\n  width: 100%;\n}\n.landing-header div[data-v-8096ad9c] {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n}\n.landing-header .logo-div[data-v-8096ad9c] {\n    width: 30%;\n    height: 100%;\n    margin-right: auto;\n}\n.landing-header .logo-div img[data-v-8096ad9c] {\n      max-width: 100%;\n      max-height: 100%;\n}\n.gdx-area[data-v-8096ad9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@media (min-width: 767px) {\n.gdx-area[data-v-8096ad9c] {\n      width: 80%;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n      margin: 70px auto 80px auto;\n}\n}\n.gdx-area .gdx-area-text[data-v-8096ad9c] {\n    background-color: #e4e3e4;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.gdx-area .gdx-area-text .gdx-area-text-div[data-v-8096ad9c] {\n      min-height: 173px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      margin: 60px 30px;\n}\n.gdx-area .gdx-area-text .gdx-area-text-div .gdx-paragraph[data-v-8096ad9c] {\n        text-align: center;\n        font-size: 14px;\n        font-family: \"Verdana\", sans-serif;\n        color: #303131;\n}\n.gdx-area .gdx-mid-logo[data-v-8096ad9c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    background-color: #5d5d5d;\n}\n.gdx-area .gdx-mid-logo .img-div[data-v-8096ad9c] {\n      height: 173px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      margin: 60px 20px;\n}\n.gdx-area .gdx-mid-logo .img-div img[data-v-8096ad9c] {\n        max-height: 100%;\n        max-width: 100%;\n        vertical-align: middle;\n}\n.info-area[data-v-8096ad9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n@media (min-width: 768px) {\n.info-area[data-v-8096ad9c] {\n      margin: 20px auto 50px auto;\n}\n}\n.info-text[data-v-8096ad9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: #303131;\n}\n@media (min-width: 768px) {\n.info-text[data-v-8096ad9c] {\n      margin: 70px auto 0 auto;\n}\n}\n.info-area-header[data-v-8096ad9c] {\n  font-family: 'Roboto';\n  font-stretch: condensed;\n  font-size: 14px;\n  text-transform: uppercase;\n  color: #666666;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n.info-area-text[data-v-8096ad9c] {\n  font-family: 'Verdana';\n  font-size: 14px;\n  line-height: 20px;\n  color: #666666;\n}\n.action-item[data-v-8096ad9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.action-item .full-button[data-v-8096ad9c] {\n    width: 100%;\n}\n.action-item .info-header-container[data-v-8096ad9c] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.action-item .text-div[data-v-8096ad9c] {\n    min-height: 100px;\n}\n.content-area[data-v-8096ad9c] {\n  height: 100%;\n  margin-bottom: 20px;\n}\n@media (max-width: 767px) {\n.content-area .info-area[data-v-8096ad9c] {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n}\n.privacy-header[data-v-8096ad9c] {\n  font-family: 'Roboto';\n  font-stretch: condensed;\n  font-size: 14px;\n  text-transform: uppercase;\n  color: #666666;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n.bold[data-v-8096ad9c] {\n  font-family: 'Alegreya Sans SC', sans-serif;\n}\n.body-bg[data-v-8096ad9c] {\n  background: #fff;\n}\n#top[data-v-8096ad9c] {\n  position: absolute;\n  top: 15px;\n  right: 50px;\n  color: #fff;\n}\n#footer[data-v-8096ad9c] {\n  background: #eeeeee;\n  background-color: #e0e0e0;\n}\n.no-box-shadow[data-v-8096ad9c] {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.text-uppercase[data-v-8096ad9c] {\n  text-transform: uppercase;\n}\n.case-study[data-v-8096ad9c] {\n  height: 270px !important;\n}\n.footer-bg[data-v-8096ad9c] {\n  background: #f3f3f3;\n  height: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1497:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("1437fdc7", content, true, {});

/***/ }),

/***/ 1707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "landing-page"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('v-parallax', {
    staticClass: "no-parallax",
    attrs: {
      "src": _vm.site_settings.styles.landing.background_image,
      "height": _vm.parallaxHeight
    }
  }, [_c('v-layout', {
    staticClass: "header-block",
    attrs: {
      "id": "header-block",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "landing-header",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "logo-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.site_settings.styles.general.logo
    }
  })]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn--flat btn--raised theme--dark auth-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn--flat btn--raised theme--dark auth-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signin')
      }
    }
  }, [_vm._v("Sign In")])])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "parallax-card"
  }, [_c('v-flex', {
    staticClass: "card-item",
    attrs: {
      "dark": ""
    }
  }, [_c('div', [_c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "15px"
    }
  }, [_vm._v("THE ONE-STOP SHOP FOR "), _c('br'), _vm._v("YOUR NEXT DEFENSE CONTRACT")])]), _vm._v(" "), _c('div', [_c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("SEARCH NEW OPPORTUNITIES, RESEARCH "), _c('br'), _vm._v("EXISTING CONTRACTS AND CONNECT NEW "), _c('br'), _vm._v("BUSINESS PARTNERS THROUGH THE "), _c('br'), _vm._v("GEORGIA DEFENSE EXCHANGE")])])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "parallax-buttons"
  }, [_c('v-flex', {
    staticClass: "get-started-button",
    attrs: {
      "md6": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    staticClass: "signup-button",
    attrs: {
      "large": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_c('span', {
    staticClass: "button-text"
  }, [_vm._v("GET STARTED")])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "returning-users-button",
    attrs: {
      "md6": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "large": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signin')
      }
    }
  }, [_c('span', {
    staticClass: "button-text"
  }, [_vm._v("RETURNING USERS")])])], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "gdx-area",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "gdx-area-text",
    attrs: {
      "md9": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "gdx-area-text-div"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center",
      "font-size": "1.5rem",
      "margin-bottom": "10px"
    }
  }, [_vm._v("INTRODUCING THE ONE-STOP SHOP FOR YOUR NEXT DEFENSE CONTRACT")]), _vm._v(" "), _c('p', {
    staticClass: "gdx-paragraph",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Our directory of Georgia defense contractors provides detailed company profile and contract history. First time user would need to create an account, while returning users just need to sign in.\n            Your Company does not need to be a defense contractor yet to search active contract opportunities.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signup-button",
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_c('span', {
    staticClass: "button-text"
  }, [_vm._v("SIGN UP")])])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "gdx-mid-logo",
    attrs: {
      "md3": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "img-div"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/gdx-logo-white.png"
    }
  })])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "row-divider",
    attrs: {
      "row": ""
    }
  }, [_c('v-divider', {
    staticClass: "dashed-divider"
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "info-text"
  }, [_c('v-flex', [_c('h5', {
    staticStyle: {
      "text-align": "center",
      "color": "#303131"
    }
  }, [_vm._v("GET STARTED ON THE GEORGIA DEFENSE EXCHANGE")])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "small": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "pa-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "block-center fa-5x"
  }, [_vm._v("fa-plus")]), _vm._v(" "), _c('h2', [_vm._v("ADD "), _c('br'), _vm._v("YOUR COMPANY")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("If you do not see your company in the lookup while creating your account, create a company listing to join the exchange.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_vm._v("SUBMIT COMPANY")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "pa-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "block-center fa-5x"
  }, [_vm._v("fa-comments")]), _vm._v(" "), _c('h2', [_vm._v("CONNECT "), _c('br'), _vm._v("AND COLLABORATE")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("Connect with other contractors in Georgia. Once your account is approved, you will be able to communicate online.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/signup')
      }
    }
  }, [_vm._v("LEARN MORE")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "pa-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "block-center fa-5x"
  }, [_vm._v("fa-share-alt")]), _vm._v(" "), _c('h2', [_vm._v("SHARE "), _c('br'), _vm._v("YOUR FEEDBACK")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("Once you've tried the Georgia exchange, share your ideas for updates. We are always looking for ways to serve the defense industry.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goTo('/')
      }
    }
  }, [_vm._v("PROVIDE INPUT")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "pa-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "block-center fa-5x"
  }, [_vm._v("fa-question")]), _vm._v(" "), _c('h2', [_vm._v("FREQUENTLY "), _c('br'), _vm._v("ASKED QUESTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v("Find out more about the special features included in this platform and how you can use them to grow your business.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "signin-button",
    attrs: {
      "block": "",
      "large": "",
      "href": "/static/GDX-user-guid-v2.pdf",
      "target": "_blank"
    }
  }, [_vm._v("FAQ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "row-divider footer-divider-first",
    attrs: {
      "row": ""
    }
  }, [_c('v-divider', {
    staticClass: "dashed-divider"
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "row-divider footer-divider-second",
    attrs: {
      "row": ""
    }
  }, [_c('v-divider', {
    staticClass: "dashed-divider"
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-expansion-panel', [_c('v-container', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h5', {
    staticClass: "privacy-header"
  }, [_vm._v("Legal, Privacy & Copyright Information")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_vm._v("\n              The Georgia Defense Exchange is compiled from third party sources and is provided “as is” without warranty of any kind. The Georgia Defense Exchange is provided for informational purposes only and the Georgia Department of Economic Development in no way guarantees the accuracy or veracity of the information contained herein nor does the Georgia Department of Economic Development accept any liability for the accuracy, content, completeness, legality, or reliability of the information contained on this website.\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('site-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1497)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1271),
  /* template */
  __webpack_require__(1707),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8096ad9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      competitiveAdvantages: [{
        name: 'Infrastructure',
        link: 'http://www.georgia.org/competitive-advantages/infrastructure/'
      }, {
        name: 'Workforce',
        link: 'http://www.georgia.org/competitive-advantages/training-hiring/'
      }, {
        name: 'Tax Credits',
        link: 'http://www.georgia.org/competitive-advantages/tax-credits/'
      }],
      businessResources: [{
        name: 'Available Buildings Tool',
        link: 'http://www.georgia.org/siteselector/'
      }, {
        name: 'International Trade',
        link: 'http://www.georgia.org/business-resources/international-trade/'
      }, {
        name: 'Small Business & Entrepreneurs',
        link: 'http://www.georgia.org/business-resources/small-business-resource-directory/'
      }],
      industries: [{
        name: 'AeroSpace',
        link: 'http://www.georgia.org/industries/aerospace/'
      }, {
        name: 'Agribusiness',
        link: 'http://www.georgia.org/industries/agribusiness/'
      }, {
        name: 'Arts',
        link: 'http://www.georgia.org/industries/arts/'
      }, {
        name: 'Automotive',
        link: 'http://www.georgia.org/industries/automotive/'
      }, {
        name: 'Contact Center',
        link: 'http://www.georgia.org/industries/contact-centers/'
      }, {
        name: 'Data Center',
        link: 'http://www.georgia.org/industries/data-centers/'
      }, {
        name: 'Defense',
        link: 'http://www.georgia.org/industries/defense/'
      }, {
        name: 'Energy and Environment',
        link: 'http://www.georgia.org/industries/energy-solutions/'
      }, {
        name: 'Entertainment',
        link: 'http://www.georgia.org/industries/entertainment/'
      }, {
        name: 'Headquarters',
        link: 'http://www.georgia.org/industries/headquarters/'
      }, {
        name: 'Fintech',
        link: 'http://www.georgia.org/industries/fintech/'
      }, {
        name: 'Food Processing',
        link: 'http://www.georgia.org/industries/food-processing/'
      }, {
        name: 'Information Technology',
        link: 'http://www.georgia.org/industries/information-technology/'
      }, {
        name: 'Life Sciences',
        link: 'http://www.georgia.org/industries/life-sciences/'
      }, {
        name: 'Logistics and Transportation',
        link: 'http://www.georgia.org/industries/logistics-services/'
      }, {
        name: 'Advanced Manufacturing',
        link: 'http://www.georgia.org/industries/advanced-manufacturing/'
      }, {
        name: 'Tourism',
        link: 'http://www.georgia.org/industries/georgia-tourism/'
      }],
      year: ''
    };
  },
  created: function created() {
    this.year = new Date().getFullYear();
  },
  computed: {
    site_settings: function site_settings() {
      return this.$store.getters.getSettings;
    },
    landing_page: function landing_page() {
      return this.$store.getters.getSettings.pages.landing_pages;
    }
  }
};

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "h3[data-v-a9ce9c7e]{font-size:18px;font-family:Roboto;color:#fff;margin-top:5px;margin-bottom:5px}p[data-v-a9ce9c7e]{color:#f5f5f5;font-size:16px;margin-top:5px;margin-bottom:5px}a[data-v-a9ce9c7e]{color:#d5e14d;text-decoration:none;display:block}a[data-v-a9ce9c7e]:hover{color:#28a028}.footer-item[data-v-a9ce9c7e]{font-family:Roboto;background-image:-webkit-gradient(linear,left top,left bottom,from(#5b5b5c),to(#131314));background-image:linear-gradient(#5b5b5c,#131314);width:100%}.footer-bg[data-v-a9ce9c7e]{background:#f3f3f3;height:auto}.before-footer-content[data-v-a9ce9c7e]{height:150px}ul[data-v-a9ce9c7e]{list-style:none}ul li[data-v-a9ce9c7e]{display:inline-block;width:50%}.vertical-divider[data-v-a9ce9c7e]{clear:both;position:relative}.vertical-divider[data-v-a9ce9c7e]:after{clear:both;content:\" \";display:block;height:0;visibility:hidden}.vertical-divider .column[data-v-a9ce9c7e]:not(:first-child):after{background:#6d6d6d;bottom:0;content:\" \";margin-left:-10px;position:absolute;top:0;width:1px}hr .divider[data-v-a9ce9c7e]{background-color:#6d6d6d}.divider-flex-rows[data-v-a9ce9c7e]{width:90%;padding:15px 0;margin:auto}.divider-layout-rows[data-v-a9ce9c7e]{width:100%;padding:15px 0;margin:auto}.footer-copyright[data-v-a9ce9c7e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.footer-copyright img[data-v-a9ce9c7e]{height:50px;vertical-align:middle}.site-map[data-v-a9ce9c7e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.site-map a[data-v-a9ce9c7e]{margin:0 15px}.site-map img[data-v-a9ce9c7e]{height:50px;vertical-align:middle}.site-map-divider[data-v-a9ce9c7e]{clear:both;position:relative}.site-map-divider[data-v-a9ce9c7e]:after{clear:both;content:\" \";display:block;height:0;visibility:hidden}.site-map-divider .site-map-column[data-v-a9ce9c7e]:not(:first-child):after{background:#6d6d6d;bottom:0;content:\" \";margin-left:5px;position:absolute;top:0;width:1px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/SiteFooter.vue"],"names":[],"mappings":"AACA,oBACE,eAAgB,AAChB,mBAAoB,AACpB,WAAe,AACf,eAAgB,AAChB,iBAAmB,CACpB,AACD,mBACE,cAAkB,AAClB,eAAgB,AAChB,eAAgB,AAChB,iBAAmB,CACpB,AACD,mBACE,cAAe,AACf,qBAAsB,AACtB,aAAe,CAChB,AACD,yBACE,aAAe,CAChB,AACD,8BACE,mBAAoB,AACpB,yFAA8F,AAC9F,kDAAoD,AACpD,UAAY,CACb,AACD,4BACE,mBAAoB,AACpB,WAAa,CACd,AACD,wCACE,YAAc,CACf,AACD,oBACE,eAAiB,CAClB,AACD,uBACI,qBAAsB,AACtB,SAAW,CACd,AACD,mCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,yCACE,WAAY,AACZ,YAAa,AACb,cAAe,AACf,SAAU,AACV,iBAAmB,CACpB,AACD,mEACE,mBAAoB,AACpB,SAAU,AACV,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,UAAW,AACX,eAAgB,AAChB,WAAa,CACd,AACD,sCACE,WAAY,AACZ,eAAgB,AAChB,WAAa,CACd,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,uCACI,YAAa,AACb,qBAAuB,CAC1B,AACD,2BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,6BACI,aAAe,CAClB,AACD,+BACI,YAAa,AACb,qBAAuB,CAC1B,AACD,mCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,yCACE,WAAY,AACZ,YAAa,AACb,cAAe,AACf,SAAU,AACV,iBAAmB,CACpB,AACD,4EACE,mBAAoB,AACpB,SAAU,AACV,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ","file":"SiteFooter.vue","sourcesContent":["\nh3[data-v-a9ce9c7e] {\n  font-size: 18px;\n  font-family: Roboto;\n  color: #FFFFFF;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\np[data-v-a9ce9c7e] {\n  color: whitesmoke;\n  font-size: 16px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\na[data-v-a9ce9c7e] {\n  color: #d5e14d;\n  text-decoration: none;\n  display: block;\n}\na[data-v-a9ce9c7e]:hover {\n  color: #28a028;\n}\n.footer-item[data-v-a9ce9c7e] {\n  font-family: Roboto;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#5b5b5c), to(#131314));\n  background-image: linear-gradient(#5b5b5c, #131314);\n  width: 100%;\n}\n.footer-bg[data-v-a9ce9c7e] {\n  background: #f3f3f3;\n  height: auto;\n}\n.before-footer-content[data-v-a9ce9c7e] {\n  height: 150px;\n}\nul[data-v-a9ce9c7e] {\n  list-style: none;\n}\nul li[data-v-a9ce9c7e] {\n    display: inline-block;\n    width: 50%;\n}\n.vertical-divider[data-v-a9ce9c7e] {\n  clear: both;\n  position: relative;\n}\n.vertical-divider[data-v-a9ce9c7e]:after {\n  clear: both;\n  content: \" \";\n  display: block;\n  height: 0;\n  visibility: hidden;\n}\n.vertical-divider .column[data-v-a9ce9c7e]:not(:first-child):after {\n  background: #6d6d6d;\n  bottom: 0;\n  content: \" \";\n  margin-left: -10px;\n  position: absolute;\n  top: 0;\n  width: 1px;\n}\nhr .divider[data-v-a9ce9c7e] {\n  background-color: #6d6d6d;\n}\n.divider-flex-rows[data-v-a9ce9c7e] {\n  width: 90%;\n  padding: 15px 0;\n  margin: auto;\n}\n.divider-layout-rows[data-v-a9ce9c7e] {\n  width: 100%;\n  padding: 15px 0;\n  margin: auto;\n}\n.footer-copyright[data-v-a9ce9c7e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.footer-copyright img[data-v-a9ce9c7e] {\n    height: 50px;\n    vertical-align: middle;\n}\n.site-map[data-v-a9ce9c7e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.site-map a[data-v-a9ce9c7e] {\n    margin: 0 15px;\n}\n.site-map img[data-v-a9ce9c7e] {\n    height: 50px;\n    vertical-align: middle;\n}\n.site-map-divider[data-v-a9ce9c7e] {\n  clear: both;\n  position: relative;\n}\n.site-map-divider[data-v-a9ce9c7e]:after {\n  clear: both;\n  content: \" \";\n  display: block;\n  height: 0;\n  visibility: hidden;\n}\n.site-map-divider .site-map-column[data-v-a9ce9c7e]:not(:first-child):after {\n  background: #6d6d6d;\n  bottom: 0;\n  content: \" \";\n  margin-left: 5px;\n  position: absolute;\n  top: 0;\n  width: 1px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("71a8954f", content, true, {});

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(874)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(878),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a9ce9c7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 878:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item"
  }, [_c('v-layout', {
    staticClass: "before-footer-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container')], 1), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "background-color": "#d5e14d"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "hidden-sm-down": ""
    }
  }, [_c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("INDUSTRIES IN GEORGIA")]), _vm._v(" "), _c('v-flex', [_c('ul', {
    staticClass: "industry-item"
  }, _vm._l((_vm.industries), function(industry, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": industry.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(industry.name))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "hidden-sm-down": ""
    }
  }, [_c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("COMPETITIVE ADVANTAGE")]), _vm._v(" "), _vm._l((_vm.competitiveAdvantages), function(advantage, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": advantage.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(advantage.name))])
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-flex-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("BUSINESS RESOURCES")]), _vm._v(" "), _vm._l((_vm.businessResources), function(resource, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": resource.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(resource.name))])
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "social-media-footer column",
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md-12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md-12": ""
    }
  }, [_c('h3', [_vm._v("CONNECT WITH US")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-email")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-facebook-box")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-youtube-play")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-rss")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-flex-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "contact-us column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("CONTACT US")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.georgia.org/about-us/contact-us/"
    }
  }, [_vm._v("Use our Contact form")]), _vm._v(" "), _c('p', [_vm._v("Call us at +1-404-962-4000")]), _vm._v(" "), _c('p', [_vm._v("+1-800-255-0056 for the hearing impaired")]), _vm._v(" "), _c('p', [_vm._v("Georgia Department of Economic Development")]), _vm._v(" "), _c('p', [_vm._v("Technology Square, 75 5th Street N.W., Suite 1200 Atlanta, GA 30308")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-layout-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "site-map site-map-divider",
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "site-map-column"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/footer-we_speak_business.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.georgia.org/sitemap",
      "target": "blank"
    }
  }, [_vm._v("Site Map")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.exploregeorgia.org/?_ga=2.117864841.1812343620.1523235297-576062532.1522934539",
      "target": "blank"
    }
  }, [_vm._v("ExploreGeorgia.org")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gaarts.org/",
      "target": "blank"
    }
  }, [_vm._v("GaArts.org")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://siteselector.georgia.org/?_ga=2.117864841.1812343620.1523235297-576062532.1522934539",
      "target": "blank"
    }
  }, [_vm._v("GeorgiaSiteSelector")])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-layout-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "footer-copyright",
    attrs: {
      "md12": ""
    }
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.year) + " Georgia Department of Economic Development. All Rights Reserved.")]), _vm._v(" "), _c('p', [_vm._v("GDEcD is an equal opportunity employer.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/footer-logo.png"
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['text', 'color', 'type', 'message'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
};

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(935),
  /* template */
  __webpack_require__(944),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 944:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-alert', {
    attrs: {
      "color": _vm.color,
      "dismissible": "",
      "value": true
    },
    on: {
      "input": _vm.onClose
    }
  }, [(_vm.type === 'html') ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/27.ea973732325168f13248.js